import Vue from 'vue'

import uiLoading from './src/ui-loading.vue';

Vue.component('ui-loading', uiLoading);

export default uiLoading;



//////////////////
// WEBPACK FOOTER
// ./~/ui-loading/index.js
// module id = 552
// module chunks = 0